(function () {
  const root = document.getElementById("jod-canvas-root");
  if (!root) return;

  const backendUrl = (root.dataset.backendUrl || "").replace(/\/$/, "");
  const handoffPage = root.dataset.handoffPage || "design-your-jacket";

  // ---- DOM refs ----
  const $stage = root.querySelector("[data-jodc-stage]");
  const $board = root.querySelector("[data-jodc-board]");
  const $svg = root.querySelector("[data-jodc-svg]");
  const $insCol = root.querySelector("[data-jodc-inspirations]");
  const $emptyHint = root.querySelector("[data-jodc-empty-hint]");
  const $synthInner = root.querySelector("[data-jodc-synthesis-inner]");
  const $synthFoot = root.querySelector("[data-jodc-synthesis-foot]");
  const $synthTitle = root.querySelector("[data-jodc-synthesis-title]");
  const $synthDesc = root.querySelector("[data-jodc-synthesis-desc]");
  const $resultCol = root.querySelector("[data-jodc-result]");
  const $resultImg = root.querySelector("[data-jodc-result-img]");
  const $status = root.querySelector("[data-jodc-status]");
  const $statusText = root.querySelector("[data-jodc-status-text]");
  const $promptForm = root.querySelector("[data-jodc-prompt-form]");
  const $promptInput = root.querySelector("[data-jodc-prompt-input]");
  const $zoomReadout = root.querySelector("[data-jodc-zoom-readout]");

  // Add modal refs
  const $addModal = root.querySelector("[data-jodc-add-modal]");
  const $addError = root.querySelector("[data-jodc-add-error]");
  const $describeLabel = root.querySelector("[data-jodc-describe-label]");
  const $describeText = root.querySelector("[data-jodc-describe-text]");
  const $uploadLabel = root.querySelector("[data-jodc-upload-label]");
  const $uploadInput = root.querySelector("[data-jodc-upload-input]");
  const $uploadPlaceholder = root.querySelector("[data-jodc-upload-placeholder]");
  const $uploadPreview = root.querySelector("[data-jodc-upload-preview]");
  const $linkLabel = root.querySelector("[data-jodc-link-label]");
  const $linkUrl = root.querySelector("[data-jodc-link-url]");

  // ---- State ----
  const state = {
    inspirations: [],          // { id, label, kind: 'text'|'image', text?, imageUrl? }
    synthesis: null,           // { imageUrl, title, description }
    history: [],               // chat-style turns, kept on the backend
    activeAddTab: "describe",
    zoom: 1,
    loading: false,
    pendingUploadDataUrl: null,
  };

  // ---- Render helpers ----
  function renderInspirations() {
    const cards = state.inspirations;
    $insCol.innerHTML = "";
    if (cards.length === 0) {
      const hint = document.createElement("p");
      hint.className = "jodc-empty-hint";
      hint.dataset.jodcEmptyHint = "";
      hint.innerHTML = `<span class="jodc-empty-hint__sparkle">✦</span>Add inspiration to begin.<br>An image, a link, or just a few words.`;
      $insCol.appendChild(hint);
      return;
    }
    cards.forEach((card) => {
      const el = document.createElement("article");
      el.className = "jodc-card";
      el.dataset.jodcCardId = card.id;
      el.innerHTML = `
        <button class="jodc-card__close" data-jodc-card-close="${card.id}" aria-label="Remove">×</button>
        <div class="jodc-card__img"${card.imageUrl ? ` style="background-image:url('${escapeAttr(card.imageUrl)}');"` : ""}>
          ${card.imageUrl ? "" : `<p class="jodc-card__img-placeholder">${escapeHtml(card.text || card.label)}</p>`}
        </div>
        <p class="jodc-card__label">${escapeHtml(card.label)}</p>
        <span class="jodc-card__connector-anchor" aria-hidden="true"></span>
      `;
      $insCol.appendChild(el);
    });
    drawConnectors();
  }

  function drawConnectors() {
    const cards = $insCol.querySelectorAll(".jodc-card");
    if (cards.length === 0 || !$synthInner) {
      $svg.innerHTML = "";
      return;
    }
    const boardRect = $board.getBoundingClientRect();
    const synthRect = $synthInner.getBoundingClientRect();
    const synthX = synthRect.left - boardRect.left;
    const synthY = synthRect.top - boardRect.top + synthRect.height / 2;

    let paths = "";
    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const x = rect.right - boardRect.left;
      const y = rect.top - boardRect.top + rect.height / 2;
      const dx = (synthX - x) * 0.55;
      paths += `<path d="M ${x} ${y} C ${x + dx} ${y}, ${synthX - dx} ${synthY}, ${synthX} ${synthY}" stroke="var(--jodc-accent)" stroke-width="1" fill="none" opacity="0.4" stroke-dasharray="3 3"/>`;
    });
    $svg.setAttribute("viewBox", `0 0 ${boardRect.width} ${boardRect.height}`);
    $svg.innerHTML = paths;
  }

  function renderSynthesis() {
    if (!state.synthesis || !state.synthesis.imageUrl) {
      $synthInner.innerHTML = `<div class="jodc-synthesis__placeholder"><p>Your synthesised jacket will appear here.</p></div>`;
      $synthFoot.hidden = true;
      $resultCol.hidden = true;
      return;
    }
    $synthInner.innerHTML = `<img src="${escapeAttr(state.synthesis.imageUrl)}" alt="Synthesised jacket">`;
    $synthFoot.hidden = false;
    $synthTitle.textContent = state.synthesis.title || "Your jacket";
    $synthDesc.textContent = state.synthesis.description || "";
    // Mirror to result card
    $resultImg.style.backgroundImage = `url('${state.synthesis.imageUrl.replace(/'/g, "\\'")}')`;
    $resultCol.hidden = false;
    drawConnectors();
  }

  function setStatus(visible, text) {
    if (visible) {
      $statusText.textContent = text || "AI is crafting your jacket…";
      $status.hidden = false;
    } else {
      $status.hidden = true;
    }
  }

  // ---- Actions ----
  root.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-jodc-action]");
    if (!btn) return;
    const action = btn.dataset.jodcAction;
    if (action === "open-add") openAddModal();
    if (action === "close-add") closeAddModal();
    if (action === "confirm-add") await confirmAdd();
    if (action === "review-customize") reviewCustomize();
    if (action === "reset") resetCanvas();
    if (action === "zoom-in") setZoom(state.zoom + 0.1);
    if (action === "zoom-out") setZoom(state.zoom - 0.1);
    if (action === "fullscreen") toggleFullscreen();
    if (action === "save") flashTooltip(btn, "Saving lands in phase 4");
    if (action === "quick-pick") flashTooltip(btn, "Quick-pick library coming soon");
  });

  root.addEventListener("click", (e) => {
    const close = e.target.closest("[data-jodc-card-close]");
    if (!close) return;
    const id = close.dataset.jodcCardClose;
    state.inspirations = state.inspirations.filter((c) => c.id !== id);
    renderInspirations();
    if (state.synthesis && state.inspirations.length === 0) {
      // optionally clear synthesis
    }
  });

  // Tabs in the modal
  root.querySelectorAll("[data-jodc-add-tab]").forEach((tab) => {
    tab.addEventListener("click", () => {
      const which = tab.dataset.jodcAddTab;
      state.activeAddTab = which;
      root.querySelectorAll("[data-jodc-add-tab]").forEach((t) =>
        t.classList.toggle("is-active", t === tab));
      root.querySelectorAll("[data-jodc-add-pane]").forEach((p) => {
        const isActive = p.dataset.jodcAddPane === which;
        p.classList.toggle("is-active", isActive);
        p.hidden = !isActive;
      });
      $addError.hidden = true;
    });
  });

  // Upload handling
  $uploadInput.addEventListener("change", async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const dataUrl = await fileToDataUrl(file);
    state.pendingUploadDataUrl = dataUrl;
    $uploadPlaceholder.hidden = true;
    $uploadPreview.src = dataUrl;
    $uploadPreview.hidden = false;
  });

  // Chips (refinement prompts)
  root.querySelectorAll("[data-jodc-chip]").forEach((chip) => {
    chip.addEventListener("click", () => {
      const text = chip.dataset.jodcChip;
      $promptInput.value = text;
      $promptForm.requestSubmit();
    });
  });

  // Prompt form
  $promptForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const prompt = $promptInput.value.trim();
    if (!prompt) return;
    $promptInput.value = "";
    await runSynthesis(prompt);
  });

  // ---- Modal ----
  function openAddModal() {
    $addModal.hidden = false;
    $addError.hidden = true;
    setTimeout(() => {
      ($describeLabel || $describeText)?.focus();
    }, 80);
  }

  function closeAddModal() {
    $addModal.hidden = true;
    state.pendingUploadDataUrl = null;
    if ($describeLabel) $describeLabel.value = "";
    if ($describeText) $describeText.value = "";
    if ($uploadLabel) $uploadLabel.value = "";
    if ($linkLabel) $linkLabel.value = "";
    if ($linkUrl) $linkUrl.value = "";
    $uploadInput.value = "";
    $uploadPlaceholder.hidden = false;
    $uploadPreview.hidden = true;
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !$addModal.hidden) closeAddModal();
  });

  async function confirmAdd() {
    $addError.hidden = true;
    try {
      const tab = state.activeAddTab;
      let card = null;
      const id = "ins_" + Math.random().toString(36).slice(2, 9);

      if (tab === "describe") {
        const label = $describeLabel.value.trim() || "Inspiration";
        const text = $describeText.value.trim();
        if (!text) throw new Error("Describe what kind of inspiration this is.");
        card = { id, label, kind: "text", text };
      } else if (tab === "upload") {
        if (!state.pendingUploadDataUrl) throw new Error("Choose an image first.");
        card = {
          id,
          label: $uploadLabel.value.trim() || "Reference image",
          kind: "image",
          imageUrl: state.pendingUploadDataUrl,
        };
      } else if (tab === "link") {
        const url = $linkUrl.value.trim();
        if (!/^https?:\/\//i.test(url)) throw new Error("Paste a full https link.");
        if (!backendUrl) throw new Error("Connect the AI backend first to fetch links.");
        const resp = await fetch(`${backendUrl}/api/fetch-image`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        });
        const data = await resp.json().catch(() => ({}));
        if (!resp.ok) throw new Error(data.error || "Couldn't fetch that link.");
        card = {
          id,
          label: $linkLabel.value.trim() || "From link",
          kind: "image",
          imageUrl: data.image,
          sourceUrl: url,
        };
      }

      if (!card) throw new Error("Pick a tab first.");
      state.inspirations.push(card);
      if (state.inspirations.length > 6) state.inspirations.shift();
      renderInspirations();
      closeAddModal();
      // Auto-trigger first synthesis
      if (state.inspirations.length === 1 && !state.synthesis) {
        await runSynthesis(null);
      } else {
        await runSynthesis(null);
      }
    } catch (err) {
      $addError.textContent = err.message || "Something went wrong.";
      $addError.hidden = false;
    }
  }

  // ---- Synthesis ----
  async function runSynthesis(promptText) {
    if (state.loading) return;
    if (state.inspirations.length === 0 && !promptText) {
      // Nothing to synthesize yet
      return;
    }
    state.loading = true;
    setStatus(true, promptText ? "Refining your jacket…" : "AI is crafting your jacket…");

    try {
      if (!backendUrl) {
        // Stub mode — fake a result
        await sleep(900);
        state.synthesis = {
          imageUrl: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=900&q=80",
          title: "Suede biker jacket",
          description: "Stub mode — connect the AI backend to generate real mockups from your inspiration.",
        };
      } else {
        const resp = await fetch(`${backendUrl}/api/canvas-render`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            inspirations: state.inspirations.map((c) => ({
              label: c.label,
              kind: c.kind,
              text: c.text,
              image: c.imageUrl,
            })),
            prompt: promptText || null,
            history: state.history,
            currentImage: state.synthesis?.imageUrl || null,
          }),
        });
        const data = await resp.json().catch(() => ({}));
        if (!resp.ok) throw new Error(data.error || `Render failed (${resp.status}).`);
        state.synthesis = {
          imageUrl: data.image,
          title: data.title || "Your bespoke jacket",
          description: data.description || "Crafted from your inspiration.",
        };
        if (data.history) state.history = data.history;
      }
      renderSynthesis();
    } catch (err) {
      console.error("[canvas]", err);
      setStatus(true, "Hmm — that didn't render. Try again or change your inspiration.");
      setTimeout(() => setStatus(false), 3500);
      state.loading = false;
      return;
    }
    setStatus(false);
    state.loading = false;
  }

  // ---- Handoff to chat tailor ----
  function reviewCustomize() {
    if (!state.synthesis) return;
    const params = new URLSearchParams();
    params.set("from", "canvas");
    if (state.synthesis.imageUrl) params.set("mockup", state.synthesis.imageUrl);
    if (state.synthesis.title) params.set("title", state.synthesis.title);
    const summary = state.inspirations
      .map((c) => `${c.label}${c.text ? ": " + c.text : ""}`)
      .join(" · ");
    if (summary) params.set("inspirations", summary);
    window.location.href = `/pages/${handoffPage}?${params.toString()}`;
  }

  // ---- Reset ----
  function resetCanvas() {
    if (!confirm("Clear the canvas and start over?")) return;
    state.inspirations = [];
    state.synthesis = null;
    state.history = [];
    renderInspirations();
    renderSynthesis();
    setStatus(false);
  }

  // ---- Zoom ----
  function setZoom(z) {
    state.zoom = Math.max(0.5, Math.min(1.5, z));
    $board.style.transform = `scale(${state.zoom})`;
    $zoomReadout.textContent = Math.round(state.zoom * 100) + "%";
    setTimeout(drawConnectors, 320);
  }

  // ---- Fullscreen ----
  function toggleFullscreen() {
    root.classList.toggle("is-fullscreen");
    setTimeout(drawConnectors, 60);
  }

  // ---- Tooltips for "coming soon" buttons ----
  function flashTooltip(btn, msg) {
    const old = btn.title;
    btn.title = msg;
    btn.style.outline = "1px solid var(--jodc-accent)";
    setTimeout(() => {
      btn.title = old;
      btn.style.outline = "";
    }, 1400);
  }

  // ---- Utils ----
  function sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }
  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    })[c]);
  }
  function escapeAttr(s) {
    return String(s).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // Re-draw connectors on resize
  window.addEventListener("resize", () => {
    requestAnimationFrame(drawConnectors);
  });

  // Initial render
  renderInspirations();
  renderSynthesis();
})();
